module.exports = __webpack_public_path__ + "static/media/ct_ago_paywall.36f0be07.png";